import { styled } from '@mui/system';
import Typography from '@mui/material/Typography';

import muiPropForwarding from 'styles/helpers/muiPropForwarding';
import {
  getMenuItemNamesLightColor,
  getMenuItemNamesMediumColor
} from 'styles/helpers/getThemeStyles';

export const StyledTypographyWithDisabled = styled(Typography, {
  shouldForwardProp: muiPropForwarding('isDisabled')
})(({ theme, isDisabled }) => {
  let color;
  if (isDisabled) {
    color = getMenuItemNamesLightColor(theme);
  } else {
    color = getMenuItemNamesMediumColor(theme);
  }

  return { color };
});
